import styled from "styled-components";
import { Wrapper } from "AppReact";

export default Wrapper(
  styled.div`
    width: 80px;
    height: 45px;
    overflow: hidden;
    position: relative;
    border-radius: 0.5rem;
  `
);
